import { render, staticRenderFns } from "./StoreManagement.vue?vue&type=template&id=45687a72&scoped=true"
import script from "./StoreManagement.vue?vue&type=script&lang=js"
export * from "./StoreManagement.vue?vue&type=script&lang=js"
import style0 from "./StoreManagement.vue?vue&type=style&index=0&id=45687a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45687a72",
  null
  
)

export default component.exports